module.exports = __webpack_public_path__ + "img/banner-espolon.c435602e.jpeg";